import {DropdownMenuItem} from "@reside/ui";

import {getResidentTestId} from "../../helper";
import {
  AdmissionFromSearch,
  downloadWorkflowPdf,
  hasArbitrationDocument,
} from "../../../../services/AdmissionsService";
import {useDownloadManager} from "../../../../hooks/useDownloadManager";

export const DownloadArbitrationPDFDropdownItem = ({
  admission,
  ...props
}: {
  admission: AdmissionFromSearch;
}) => {
  const {start} = useDownloadManager();

  if (!hasArbitrationDocument(admission.templateDocumentTypes)) {
    return null;
  }

  return (
    <DropdownMenuItem
      pointer
      onClick={() => {
        start("Download Arbitration", () =>
          downloadWorkflowPdf({
            workflowId: admission.id,
            type: "arbitration",
            status: admission.status,
          }),
        );
      }}
      testId={getResidentTestId(admission, "downloadArbitrationPdf")}
      {...props}
    >
      Download Arbitration
    </DropdownMenuItem>
  );
};
